
import { TranslationSet } from '../../types';

export const galleryPdfExport: TranslationSet = {
  'gallery.exportPdf': {
    en: 'Export PDF',
    ja: 'PDFをエクスポート',
    es: 'Exportar PDF',
    zh: '导出PDF',
    fa: 'خروجی PDF'
  },
  'gallery.exportPdfTitle': {
    en: 'Export Gallery to PDF',
    ja: 'ギャラリーをPDFにエクスポート',
    es: 'Exportar Galería a PDF',
    zh: '将图库导出为PDF',
    fa: 'خروجی گالری به PDF'
  },
  'gallery.exportPdfDescription': {
    en: 'Customize your PDF export options below',
    ja: '以下のPDFエクスポートオプションをカスタマイズします',
    es: 'Personaliza tus opciones de exportación de PDF a continuación',
    zh: '在下方自定义您的PDF导出选项',
    fa: 'گزینه‌های خروجی PDF خود را در زیر سفارشی کنید'
  },
  'gallery.includeMilestones': {
    en: 'Include milestones',
    ja: 'マイルストーンを含める',
    es: 'Incluir hitos',
    zh: '包括里程碑',
    fa: 'شامل نقاط عطف'
  },
  'gallery.includePhotoDates': {
    en: 'Include photo dates',
    ja: '写真の日付を含める',
    es: 'Incluir fechas de fotos',
    zh: '包括照片日期',
    fa: 'شامل تاریخ عکس‌ها'
  },
  'gallery.includeDecorations': {
    en: 'Include decorations',
    ja: '装飾を含める',
    es: 'Incluir decoraciones',
    zh: '包括装饰',
    fa: 'شامل تزئینات'
  },
  'gallery.generating': {
    en: 'Generating...',
    ja: '生成中...',
    es: 'Generando...',
    zh: '生成中...',
    fa: 'در حال ایجاد...'
  },
  'gallery.downloadPdf': {
    en: 'Download PDF',
    ja: 'PDFをダウンロード',
    es: 'Descargar PDF',
    zh: '下载PDF',
    fa: 'دانلود PDF'
  },
  'gallery.photoCollection': {
    en: 'Photo Collection',
    ja: '写真コレクション',
    es: 'Colección de Fotos',
    zh: '照片集',
    fa: 'مجموعه عکس'
  },
  'gallery.pdfGenerated': {
    en: 'PDF Generated',
    ja: 'PDF生成完了',
    es: 'PDF Generado',
    zh: 'PDF已生成',
    fa: 'PDF ایجاد شد'
  },
  'gallery.pdfDownloadedSuccess': {
    en: 'Your gallery PDF has been downloaded successfully',
    ja: 'ギャラリーPDFが正常にダウンロードされました',
    es: 'El PDF de tu galería se ha descargado con éxito',
    zh: '您的图库PDF已成功下载',
    fa: 'PDF گالری شما با موفقیت دانلود شد'
  },
  'gallery.pdfError': {
    en: 'PDF Error',
    ja: 'PDFエラー',
    es: 'Error de PDF',
    zh: 'PDF错误',
    fa: 'خطای PDF'
  },
  'gallery.pdfGenerationFailed': {
    en: 'Failed to generate PDF. Please try again with fewer photos.',
    ja: 'PDFの生成に失敗しました。写真の数を減らして再試行してください。',
    es: 'Error al generar PDF. Inténtalo de nuevo con menos fotos.',
    zh: '生成PDF失败。请减少照片数量后重试。',
    fa: 'ایجاد PDF با خطا مواجه شد. لطفا با عکس‌های کمتر مجددا امتحان کنید.'
  },
  'gallery.photoPreparationFailed': {
    en: 'Failed to prepare photos for PDF. Please try again.',
    ja: 'PDFの写真準備に失敗しました。もう一度お試しください。',
    es: 'Error al preparar fotos para PDF. Inténtalo de nuevo.',
    zh: '准备PDF照片失败。请重试。',
    fa: 'آماده‌سازی عکس‌ها برای PDF با خطا مواجه شد. لطفا مجددا امتحان کنید.'
  },
  'gallery.noPhotos': {
    en: 'No Photos',
    ja: '写真なし',
    es: 'Sin Fotos',
    zh: '没有照片',
    fa: 'بدون عکس'
  },
  'gallery.recentphotos': {
    en: 'Recent Photos',
    ja: '最近の写真',
    es: 'Fotos Recientes',
    zh: '最近照片',
    fa: 'عکس‌های اخیر'
  },
  'gallery.milestonephotos': {
    en: 'Milestone Photos',
    ja: 'マイルストーン写真',
    es: 'Fotos de Hitos',
    zh: '里程碑照片',
    fa: 'عکس‌های نقاط عطف'
  },
  'gallery.firstyear': {
    en: 'First Year',
    ja: '最初の一年',
    es: 'Primer Año',
    zh: '第一年',
    fa: 'سال اول'
  },
  'gallery.familymoments': {
    en: 'Family Moments',
    ja: '家族の瞬間',
    es: 'Momentos Familiares',
    zh: '家庭时刻',
    fa: 'لحظات خانوادگی'
  },
  'gallery.specialevents': {
    en: 'Special Events',
    ja: '特別なイベント',
    es: 'Eventos Especiales',
    zh: '特别活动',
    fa: 'رویدادهای ویژه'
  },
  'gallery.pregnancycollection': {
    en: 'Pregnancy Collection',
    ja: '妊娠コレクション',
    es: 'Colección de Embarazo',
    zh: '孕期收藏',
    fa: 'مجموعه بارداری'
  }
};
